export const gps = {
  getCoords () {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    }

    return new Promise((resolve, reject) => {
      const success = pos => resolve(pos.coords)

      const error = err => {
        reject(Error(err.message))
      }

      navigator.geolocation.getCurrentPosition(success, error, options)
    })
  }
}
